"use client";

import React from "react";

import { TooltipProvider } from "@/components/flowbite/tooltip";
import ServerErrorWrapper from "@/hocs/server-error.hoc";
import StoreProvider from "@/providers/store/store.provider";

export default function ExternalLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <StoreProvider>
      <ServerErrorWrapper>
        <TooltipProvider delayDuration={300}>
          {children}
        </TooltipProvider>
      </ServerErrorWrapper>
    </StoreProvider>
  );
}
